// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quoted-text{color:var(--color-text-maxcontrast) summary;color-cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/components/MessagePlainTextBody.vue"],"names":[],"mappings":"AACA,aACC,2CAAA,CAGC,oBAAA","sourcesContent":["\n.quoted-text {\n\tcolor: var(--color-text-maxcontrast)\n\n\tsummary {\n\t\tcursor: pointer\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
